import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import NamedDto from 'modules/base/dto/NamedDto';
import nBossConnection from 'modules/base/service/nBossConnection';

class ElementTypeEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'elementTypeEditControl';
	}

	/**
	 * @return {Promise<NamedDto>}
	 */
	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new NamedDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<NamedDto>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new NamedDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {NamedDto} dto
	 * @return {Promise<EntityValidationResult>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {NamedDto} dto
	 * @return {Promise<EntityValidationResult>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new ElementTypeEditService();
